module.exports = __webpack_public_path__ + "static/indienreisen-77f058b0c36acaabf4202358e229ba0c.svg";